module.exports = __webpack_public_path__ + "img/bien-etre.507648ca.jpg";